import {EmailData} from './EmailData'

export type CompanyPolicyDocEmailData = EmailData & {
    smeDomain: string
    passwordValidDays: string
}
